module.exports = __webpack_public_path__ + "img/icon-sport.82195c6.webp";